export default "__VITE_ASSET__D0KBgFEI__"